(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-stories"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('customer-stories-slider')) {
    class CustomerStoriesSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-cstory-track]');
        if (!this.track) return;

        this.slides = Array.from(this.track.querySelectorAll('[data-cstory-slide]'));
        this.prevBtn = this.querySelector('[data-cstory-prev]');
        this.nextBtn = this.querySelector('[data-cstory-next]');
        this.dotsWrap = this.querySelector('[data-cstory-dots]');
        this.loop = this.dataset.loop === 'true';
        this.autoplayOn =
          this.dataset.autoplay === 'true' &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.speed = Math.max(2, parseInt(this.dataset.speed, 10) || 5) * 1000;
        this.index = 0;
        this.pageCount = 0;
        this.paused = false;

        this.track.addEventListener(
          'scroll',
          () => {
            cancelAnimationFrame(this.raf);
            this.raf = requestAnimationFrame(() => this.update());
          },
          { passive: true }
        );

        if (this.prevBtn) {
          this.prevBtn.addEventListener('click', () => {
            this.go(this.index - 1);
            this.start();
          });
        }
        if (this.nextBtn) {
          this.nextBtn.addEventListener('click', () => {
            this.go(this.index + 1);
            this.start();
          });
        }

        if ('ResizeObserver' in window) {
          this.ro = new ResizeObserver(() => this.build());
          this.ro.observe(this.track);
        } else {
          this.onResize = () => this.build();
          window.addEventListener('resize', this.onResize);
        }

        // Theme editor: block select karne par us story par scroll
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target);
          if (i > -1) {
            this.paused = true;
            this.stop();
            this.go(Math.min(i, this.pageCount - 1), 'auto');
          }
        });
        this.addEventListener('shopify:block:deselect', () => {
          this.paused = false;
          this.start();
        });

        if (this.autoplayOn) {
          ['mouseenter', 'focusin', 'touchstart'].forEach((ev) =>
            this.addEventListener(ev, () => this.stop(), { passive: true })
          );
          ['mouseleave', 'focusout', 'touchend'].forEach((ev) =>
            this.addEventListener(ev, () => this.start(), { passive: true })
          );
        }

        this.build();
        this.start();
      }

      disconnectedCallback() {
        this.stop();
        if (this.ro) this.ro.disconnect();
        if (this.onResize) window.removeEventListener('resize', this.onResize);
      }

      getStep() {
        const a = this.slides[0];
        const b = this.slides[1];
        return (b ? b.offsetLeft - a.offsetLeft : a.offsetWidth) || 1;
      }

      getPages() {
        const step = this.getStep();
        const gap = Math.max(0, step - this.slides[0].offsetWidth);
        const perView = Math.max(1, Math.round((this.track.clientWidth + gap) / step));
        return Math.max(1, this.slides.length - perView + 1);
      }

      build() {
        if (!this.slides.length) return;
        const count = this.getPages();

        if (count !== this.pageCount) {
          this.pageCount = count;
          if (this.dotsWrap) {
            this.dotsWrap.innerHTML = '';
            for (let i = 0; i < count; i++) {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'cstory__dot';
              dot.setAttribute('aria-label', 'Go to story ' + (i + 1));
              dot.addEventListener('click', () => {
                this.go(i);
                this.start();
              });
              this.dotsWrap.appendChild(dot);
            }
            this.dotsWrap.hidden = count <= 1;
          }
          this.start();
        }
        this.update();
      }

      update() {
        const count = this.pageCount || 1;
        const maxScroll = this.track.scrollWidth - this.track.clientWidth;
        let i = Math.round(this.track.scrollLeft / this.getStep());
        if (this.track.scrollLeft >= maxScroll - 2) i = count - 1;
        i = Math.min(Math.max(i, 0), count - 1);
        this.index = i;

        if (this.dotsWrap) {
          Array.from(this.dotsWrap.children).forEach((d, n) =>
            d.setAttribute('aria-current', n === i ? 'true' : 'false')
          );
        }
        if (this.prevBtn) this.prevBtn.hidden = count <= 1 || (!this.loop && i === 0);
        if (this.nextBtn) this.nextBtn.hidden = count <= 1 || (!this.loop && i === count - 1);
      }

      go(i, behavior = 'smooth') {
        const count = this.pageCount || 1;
        if (i < 0) i = this.loop ? count - 1 : 0;
        if (i >= count) i = this.loop ? 0 : count - 1;
        this.track.scrollTo({ left: i * this.getStep(), behavior: behavior });
      }

      start() {
        this.stop();
        if (!this.autoplayOn || this.paused || this.pageCount <= 1) return;
        this.timer = setInterval(() => {
          this.go(this.index + 1 >= this.pageCount ? 0 : this.index + 1);
        }, this.speed);
      }

      stop() {
        clearInterval(this.timer);
      }
    }

    customElements.define('customer-stories-slider', CustomerStoriesSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
